/**
 * Wait for a specified duration. Primarily used a utility for async testing.
 *
 * @param delayMS - The duration to wait in milliseconds.
 * @param abortSignal - An optional AbortSignal to abort the wait.
 */
export async function wait(delayMS: number, abortSignal?: AbortSignal) {
  await new Promise((resolve) => {
    abortSignal?.addEventListener("abort", handleAbort, { once: true });

    const timeoutId = setTimeout(() => {
      abortSignal?.removeEventListener("abort", handleAbort);
      resolve(true);
    }, delayMS);

    function handleAbort() {
      clearTimeout(timeoutId);
      resolve(true);
    }
  });
}
